<template>
    <div class="stuJoinClass padding-x-y position-relative">
        <common-dialog @closeDialog="closeDialog"
                        :dialog-show="dialogShow"
                        :model-obj="modelObj"
                        :show-close="false"
                        :closeOnPressEscape="false"
                        :closeOnClickModal="false"
                        >
            <div class="padding-x-y">
                <el-input style="width:200px;" v-model="realName" size="medium" placeholder="输入真实姓名">
                </el-input>
                <div class="text-right margin-medium-top">
                    <el-button size="medium" type="primary" @click="bindRealName">确定</el-button>
                </div>
            </div>
        </common-dialog>
        <!--展示退出班级弹窗-->
<!--        <common-dialog @closeDialog="closeOutClass"-->
<!--                        :dialog-show="needJoinShow"-->
<!--                        :model-obj="modelObj">-->
<!--            <div class="padding-x-y">-->
<!--               <div>您确定</div>-->
<!--                <div class="text-right margin-medium-top">-->
<!--                    <el-button size="medium" type="primary" @click="bindRealName">确定</el-button>-->
<!--                </div>-->
<!--            </div>-->
<!--        </common-dialog>-->
        <!--展示填写班主任姓名弹窗-->
        <common-dialog @closeDialog="closeWriteMaster"
                        :dialog-show="hasHeaderMaster"
                        :model-obj="masterModelObj">
            <div class="padding-x-y">
                <el-input style="width:200px;" v-model="settingMasterName" clearable
                          size="medium" placeholder="输入班主任姓名">
                </el-input>
                <div class="text-right margin-medium-top">
                    <el-button size="medium"  @click="hasHeaderMaster=false,settingMasterName=''">取消</el-button>
                    <el-button size="medium" type="primary" @click="confirmMasterName">确定</el-button>
                </div>
            </div>
        </common-dialog>
        <!--进入此页面检测用户名，如果为false则弹窗，让用户输入真实姓名-->
        <div class="title border-bottom delFloat">
            <div class="float-left" v-show="controllerJoinClassShow">加入班级</div>
            <div class="float-left" v-show="!controllerJoinClassShow">我的班级</div>
            <div class="float-right" v-show="studentAddClassInfo.length>0">
                <el-button size="medium"
                           @click="controllerJoinClassShow=true"
                           type="primary"
                           v-show="!controllerJoinClassShow">
                    加入班级
                </el-button>
                <el-button size="medium"
                           type="primary"
                           @click="controllerJoinClassShow=false"
                           v-show="controllerJoinClassShow">
                    我的班级
                </el-button>
            </div>
        </div>
        <div v-show="!loading">
            <!--展示已加入班级的列表-->
            <div class="delFloat joinedClassList margin-medium-top" v-show="!controllerJoinClassShow">
                <div class="float-left delFloat joinClass margin-medium-right"
                     v-for="(item,index) in studentAddClassInfo"
                    :key="index">
                    <div class="headIcon float-left margin-right"></div>
                    <div class="rightContent float-left">
                        <div>{{item.className}}</div>
                        <div class="text-small-secondary text-d-size">{{item.teacherName!==null?item.teacherName:'暂无'}}</div>
                    </div>
                </div>
            </div>
            <div v-show="controllerJoinClassShow" class="reminder border margin-top">
                <div class="text-medium-secondary">温馨提示</div>
                <div class="text-small-secondary text-s-size">
                    系统未能检测到您的学校信息，请通过下方搜索功能找到您的学校，再加入对应班级。
                </div>
            </div>
            <div v-show="controllerJoinClassShow" class="thirdLine">
                <div class="margin-medium-top ">
                    <div style="color:red;" v-show="reminderSearch" class="text-s-size">
                        所在区域没有所符合条件的学校
                    </div>
                    <el-autocomplete
                            v-show="hideSearchSchoolInput"
                            style="width:500px;"
                            size="medium"
                            prefix-icon="el-icon-search"
                            v-model="searchSchoolVal"
                            :trigger-on-focus="false"
                            :fetch-suggestions="querySearchAsync"
                            placeholder="请输入学校名称搜索班级"
                            @select="handleSelect"
                    >
                    </el-autocomplete>
                </div>
                <div v-show="gradeList.length>0">
                    <div class="schoolInfoLine margin-y">
                        <!--                山东省 / 济南市 / 长清区 长清第一中学-->
                        {{schoolInfo}}
                    </div>
                    <div class="text-small-secondary">选择年级:</div>
                    <div class="gradeBtn">
                        <el-button class="margin-right" :plain="!gradeId===item.gradeYear"
                                   :type="gradeId===item.gradeYear?'primary':''"
                                   size="medium"
                                   @click="selectGrade(item.gradeName)"
                                   v-for="item in gradeList" :key="item.gradeYear" >
                            {{item.gradeName}}
                        </el-button>
                    </div>
                    <div class="text-small-secondary">
                        选择班级:
                    </div>
                    <div class="border classBigBox padding" >
                        <div v-show="adminClassList.length>0||teacherClassList.length>0">
                            <div>
                                <div class="classTitle">加入行政班</div>
                                <div class="classBtnBox">
                                    <div>
                                        <el-button v-for="item in adminClassList"
                                                   @click="!item.hasJoin?joinClassCheck(item,'行政班'):''"
                                                   :key="item.classId"
                                                   class="classBox"

                                                   :type="item.hasJoin?'primary':''">
                                            <div class="className text-ellipsis" :class="item.hasJoin?'activec':''" :title="item.className.length>5?item.className:''">{{item.className}}</div>
                                            <div class="text-s-size text-l-secondary">{{item.graduateYearStr}}</div>
                                        </el-button>
                                    </div>
                                    <div class="text-center">
                                        <empty content="暂无行政班" v-show="adminClassList.length<1" :text-size="16" :widths="90" :heights="90">
                                        </empty>
                                    </div>
                                </div>
                            </div>
                            <el-divider>
                            </el-divider>
                            <div>
                                <div class="classTitle">加入教学班</div>
                                <div class="classBtnBox">
                                    <div>
                                        <el-button @click="!item.hasJoin?joinClassCheck(item,'教学班'):''"
                                                   v-for="item in teacherClassList"
                                                   :key="item.classId"
                                                   class="classBox"
                                                   :type="item.hasJoin?'primary':''"
                                        >
                                            <div class="className text-ellipsis" :class="item.hasJoin?'activec':''"
                                                 :title="item.className.length>5?item.className:''">
                                                {{item.className}}</div>
                                            <div class="text-s-size text-l-secondary">{{item.graduateYearStr}}</div>
                                        </el-button>
                                    </div>
                                    <div class="text-center">
                                        <empty content="暂无教学班" v-show="teacherClassList.length<1" :text-size="16" :widths="90" :heights="90">
                                        </empty>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="margin-medium-top text-s-size text-center text-l-secondary" v-show="adminClassList.length<1&&teacherClassList.length<1">
                            <div>对不起，你所在的年级还没有创建班级，你可以联系你的班主任在高招教育网创建班级</div>
                            <div>班主任可以致电 <el-button type="text" size="small">400-0127-985</el-button> 联系高招教育网客服</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <loading :show="loading">

        </loading>

    </div>
</template>
<script>
    import {message,messageBox} from 'element-ui'
    import {
        bindRealName,
        checkAddSingleStudentToClass,
        checkRealName,
        getClassList,
        getSchoolList, stuClassList,
        stuGetSchoolInfo, stuJoinSchoolClass
    } from "../../../config";
    export default {
        name: "stuJoinClass",
        data(){
           return{
               realName:'',
               //获取所选的学校信息展示
               schoolInfo:'',
               searchSchoolVal:'',
               gradeId:1,
               gradeList:[],
               reminderSearch:false,
               adminClassList:[],
               teacherClassList:[],
               dialogShow:false,
               modelObj:{
                   title:'修改真实姓名',
                   width:'450px',
                   center:false
               },
               masterModelObj:{
                   title:'填写班主任姓名',
                   width:'450px',
                   center:false
               },
               //设置所填写的班主任姓名
               settingMasterName:'',
               schoolId:'',
               //是否隐藏查询学校的文本框
               hideSearchSchoolInput:false,
               //检测班级时获取新班级id
               newClassId:'',
               //检测班级时获取旧班级id
               oldClassId:'',
               //检测是否从已加入的班级中退出
               needJoinConfirm:false,
               //控制已加入班级提示退出班级弹窗显示
               needJoinShow:false,
               //检测用户名班主任的姓名
               hasHeadTeacher:false,
               //控制填写班主任的弹窗显示
               hasHeaderMaster:false,
               //获取已加入班级的名称(旧班级名称)
               getSelectedClassName:'',
               //如果学生加入班级了则默认显示另一种表现形式
               studentAddClassInfo:[],
               //控制加入班级页面展示
               controllerJoinClassShow:false,
               loading:false,
           }
        },
        mounted(){
          this.checkRealName();
          //查出学校信息
          this.getSchoolInfo();
          this.searchClassList();
        },
        methods:{
            //查出学生加入班级的列表
            async searchClassList(){
                this.loading=true;
                let result=await stuClassList();
                if(result.status){
                    if(result.data.length>0){
                        this.studentAddClassInfo=result.data;
                        this.controllerJoinClassShow=false;
                    }else{
                        this.controllerJoinClassShow=true;
                    }
                    this.loading=false;
                }else{
                    this.loading=false;
                }
            },
            //进入此页面默认查询，如果没有schoolId等相关信息则显示查询学校文本框,否则查询隐藏
            async getSchoolInfo(){
                let result=await stuGetSchoolInfo();
                if(result.status){
                    if(result.data.length>0){
                        this.schoolId=result.data[0].schoolId;
                        this.hideSearchSchoolInput=false;
                        if(this.schoolId!==''){
                            this.getClassList(this.schoolId);
                        }
                    }else{
                        this.hideSearchSchoolInput=true;
                    }
                }else{

                }
            },
            //关闭修改真实姓名窗口
            closeDialog(){
               this.dialogShow=false;
            },
            //确认修改班主任姓名弹窗
            confirmMasterName(){
                this.hasHeaderMaster=false;
                this.joinClass();
            },
            //关闭填写班主任的弹窗显示
            closeWriteMaster(){
              this.hasHeaderMaster=false;
            },
            //检测真实姓名，如果返回false则提示用户输入真实姓名
            async checkRealName(){
               let result=await checkRealName();
               if(result.status){
                   this.dialogShow=!result.data;
               }
            },
            async bindRealName(){
                let nameZz= /^[\u2E80-\u9FFF]{2,20}$/;
                if(!nameZz.test(this.realName)){
                    message({
                        message:'姓名格式不正确',
                        type:'error'
                    });
                    return false;
                }
                let result=await bindRealName(this.realName);
                if(result.status){
                    message({
                        message:'姓名修改成功',
                        type:'success'
                    });
                    this.checkRealName();
                    // this.dialogShow=false;
                }
            },
            //加入班级前的检测接口
            async joinClassCheck(val,classType){
                let result=await checkAddSingleStudentToClass(val.classId);
                if(result.status){
                    this.newClassId=result.data.newClassId;

                    this.oldClassId=result.data.oldClassId;
                    this.hasHeadTeacher=result.data.hasHeadTeacher;
                    this.needJoinConfirm=result.data.needJoinConfirm;
                    if(this.needJoinConfirm){
                        let zhi=[];
                        if(classType==='行政班'){
                            zhi=this.adminClassList.filter((val)=>{
                                return this.oldClassId===val.classId;
                            })

                        }else if(classType==='教学班'){
                             zhi=this.teacherClassList.filter((val)=>{
                                return this.oldClassId===val.classId;
                            })
                        }
                        if(zhi.length>0){
                           this.getSelectedClassName= zhi[0].className;
                        }
                    }
                    if(result.data.needJoinConfirm){
                        //展示是否要从XX班级退出弹窗
                        messageBox.confirm('确定退出'+this.getSelectedClassName+'班级加入'+val.className+'班级吗?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            if(result.data.hasHeadTeacher){
                                //展示是否需要用户填写班主任的姓名
                                this.hasHeaderMaster=true;
                            }else{
                              this.joinClass();
                            }
                        }).catch(() => {

                        });
                    }else if(result.data.hasHeadTeacher){
                        //展示是否需要用户填写班主任的姓名
                        this.hasHeaderMaster=true;
                    }else{
                        this.joinClass();
                    }
                }
            },
            //执行加入班级接口
            async joinClass(){
                let result=await stuJoinSchoolClass(this.schoolId,this.gradeId,
                    this.newClassId,this.oldClassId,this.settingMasterName);
                    if(result.status){
                        message({
                            message:'加入班级成功',
                            type:'success'
                        })
                        this.getClassList();
                    }
            },
            selectGrade(val){
                let zhi=this.gradeList.filter((smallVal)=>{
                    return smallVal.gradeName===val;
                });
                this.adminClassList=zhi[0].adminClass;
                this.teacherClassList=zhi[0].teacherClass;
                this.gradeId=zhi[0].gradeYear;
            },
            //文本框输入内容搜索院校查询相关
            async querySearchAsync(queryString, cb){
                let result=await getSchoolList(queryString);
                if(result.status){
                    let zhi=[];
                    result.data.forEach((val)=>{
                        zhi.push({
                            value:val.schoolName+'\t('+val.provinceName+' / '+val.cityName+' / '+val.areaName+' ) ',
                            address:val.schoolId
                        })
                    });
                    if(zhi.length<1){
                        this.reminderSearch=true;
                    }else if(zhi.length>1||this.searchSchoolVal===''){
                        this.reminderSearch=false;
                    }
                    var results = queryString ? zhi.filter(this.createStateFilter(queryString)) : zhi;
                    cb(results);
                }
            },
            //文本框输入内容搜索院校查询相关
            createStateFilter(queryString){
                return (state) => {
                    return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            //选择所匹配的内容，查出相关班级
            handleSelect(val){

                let zhi=val.value;
                let endL=zhi.indexOf(')')-(zhi.indexOf('(')+1);
                this.schoolInfo=zhi.substr(zhi.indexOf('(')+1,endL)+zhi.substr(0,zhi.indexOf('('));
                this.schoolId=val.address;
                this.getClassList(val);
            },
            //根据所选择的学校ID查询当前学校下的所有班级列表
            async getClassList(){

                let result=await getClassList(this.schoolId);
                if(result.status){
                    this.gradeId=result.data[0].gradeYear;
                    this.gradeList=result.data;
                    this.adminClassList=result.data[0].adminClass;
                    this.teacherClassList=result.data[0].teacherClass;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .stuJoinClass{
        margin-top: 20px;
        background: #ffffff;
        min-height: 200px;
        .joinedClassList{
            .joinClass{
               .headIcon{
                  border-radius: 50%;
                  width:64px;
                  height:64px;
                  background: #e5e5e5;
               }
               .rightContent{
                   div{
                       height:32px;
                       line-height: 32px;
                       font-size:16px;
                   }
               }
            }
        }
        .title{
            font-size:18px;
            color:#0D0D0D;
            padding-bottom: 20px;
        }
        .reminder{
            padding:15px 15px;
        }
        .thirdLine{
            .gradeBtn{
                margin:10px 0 20px 0;
            }
            .classBigBox{
                margin: 10px 0 10px 0;
                min-height:200px;
                background:#fafcff;
                .classBox{
                    margin: 10px 10px 10px 0;
                    width: 140px;
                }
                .classTitle{
                    color: #7c89a7;
                    font-weight: bolder;
                }
                .classBtnBox{

                    color:#7c89a7;
                    .className{
                        color:#7c89a7;
                    }
                    .className.activec{
                        color: #ffffff;
                    }
                }
            }
        }
    }
</style>
